import { Tick } from 'chart.js'
import { formatValue } from './formatValueWithPrecision'

export const roundTicksTo1Decimal = (tickValue: string | number, index: number, ticks: Tick[]) => {
	if (ticks.length - 1 === index) return undefined

	const value = Number(tickValue)

	return Number(formatValue(value, 'consumption').replace(',', '.'))
}
